import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import apiInstance from '../../Apis/Axios';
import { ASSETS_SERVICE } from '../EndPoints';

export const fullDBRestore = createAsyncThunk('dbBackUp/fullDBRestore', async (body) => {
    for (const value of body.values()) {
    }
    let response = await apiInstance
        .post(ASSETS_SERVICE.fullDBRestore, { file: body }, { 'Content-Type': 'multipart/form-data' })
        .catch((error) => {
            toast.error(error?.response?.data?.message);
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const getAllEntities = createAsyncThunk('dbBackUp/getAllEntities', async () => {
    let response = await apiInstance
        .get(ASSETS_SERVICE.getAllEntities)
        .then((response) => {
            // toast.success(response?.data?.message);
            return response;
        })
        .catch((error) => {
            toast.error(error?.response?.data?.message);
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetRecordInTimePeriod = createAsyncThunk('dbBackUp/GetRecordInTimePeriod', async (body) => {
    const { from, to, table, pagination } = body;
    let response = await apiInstance
        .post(ASSETS_SERVICE.getRecordInTimePeriod(table, from, to), pagination)
        .then((response) => {
            if (response?.data?.data?.content?.length > 0) {
                toast.success('Backup Data Found');
            } else {
                toast.warn('Sorry! No Data Backup is Avalaible');
            }
            // toast.success(response?.data?.message);

            return response;
        })
        .catch((error) => {
            toast.error(error?.response?.data?.message);
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetInformationById = createAsyncThunk('dbBackUp/getInformationById', async (body) => {
    const { id, table } = body;

    let response = await apiInstance
        .get(ASSETS_SERVICE.getInformationById(id, table))
        .then((response) => {
            toast.success(response?.data?.message);
            return response;
        })
        .catch((error) => {
            toast.error(error?.response?.data?.message);
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const RestoreTableInformation = createAsyncThunk('dbBackUp/RestoreTableInformation', async (body) => {
    const { table, list } = body;
    let response = await apiInstance
        .put(`${ASSETS_SERVICE.restoreTableInformation}${table}`, list)
        .then((response) => {
            toast.success(response?.data?.message);
            return response;
        })
        .catch((error) => {
            toast.error(error?.response?.data?.message);
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateDataBaseBackUp = createAsyncThunk('dbBackUp/CreateDataBaseBackUp', async (fileName) => {
    let response = await apiInstance
        .get(`${ASSETS_SERVICE.createDataBaseBackUp}${fileName}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
